import { TypeDefinitions } from './definition.js';
export function fix(type, props, styles) {
    // TODO: Couldnt figure out how to fix the type narrowing here
    return TypeDefinitions[type] ? TypeDefinitions[type].fix(props, styles) : props;
}
export function PropsConstructor(type, props, styles) {
    // TODO: Couldnt figure out how to fix the type narrowing here
    return TypeDefinitions[type] ? TypeDefinitions[type].Props(props) : props;
}
export function summarize(type, props, styles, formId) {
    return TypeDefinitions[type].summarize(props, styles, formId);
}
export const Props = Object.assign(PropsConstructor, { fix });
//# sourceMappingURL=props.js.map